module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"missing":"Gone","new":"New"},"es":{"missing":"Desaparecido","new":"Nuevo"},"fr":{"missing":"Disparu","new":"Nouveau"},"it":{"missing":"Scomparso","new":"Nuovo"},"pt":{"missing":"Desapareceu","new":"Novo"},"pl":{"missing":"Zniknął","new":"Nowy"}}')
  delete Component.options._Ctor
}
